import { isComingFromNativeApp } from "@/utils/nativeAppUTMParams";

import { getLandingPageBuilderBySlug } from "./getLandingPageBuilderData";

export type ThemeTypes = "men" | "app" | "master";
/**
 * Determines the current theme based on the URL path and search parameters.
 *
 * @param pathname The URL path to check. Can be undefined.
 * @returns The theme name as a string: "app", "men", or "master".
 */
export const currentTheme = (pathname: string | undefined): ThemeTypes => {
  // Get the current path from the provided argument or the window location.
  const path = pathname ? pathname : typeof window !== "undefined" ? window.location.pathname : "/";
  const { isComingFromApp } = isComingFromNativeApp();

  if (isComingFromApp) {
    return "app";
  }

  const data = getLandingPageBuilderBySlug(path);
  /*
   * If the path includes "/men/" or "/men50/", return "men".
   * This logic assumes that paths like "/men/core" or "/men50/core-3-month" should also get the "men" theme.
   * If the page comes from the landing page builder, we will check the data for the menTheme property.
   */
  if (path.includes("/men/") || (!!data && data.menTheme)) {
    return "men";
  }

  // If none of the above conditions are met, return "master".
  return "master";
};
